var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.640625,
    y: 0.585938,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "white",
    stroke: "#ECEDEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0257 28.9175H13.7315V19.9178L8.4375 15.9473V27.3293C8.4375 28.2081 9.14954 28.9175 10.0257 28.9175Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4375 28.9175H30.1433C31.0221 28.9175 31.7315 28.2055 31.7315 27.3293V15.9473L26.4375 19.9178",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4375 13.0361V19.9182L31.7315 15.9477V13.8302C31.7315 11.8661 29.4895 10.7464 27.9198 11.9243",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7344 19.9173V13.0352L20.0872 17.7997L26.4399 13.0352V19.9173L20.0872 24.6819",
    fill: "#EA4335"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 13.8302V15.9477L13.7315 19.9182V13.0361L12.2492 11.9243C10.6769 10.7464 8.4375 11.8661 8.4375 13.8302Z",
    fill: "#C5221F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/Gmail.2b19f9f58c58a903a74c05c844df2be8.svg";
export { ForwardRef as ReactComponent };